// BanChat uses one proactive conversation opener. Follow-up service messages
// continue in the open WhatsApp customer-service window.
export const LOANS_TEMPLATE_DRAFTS = [
  {
    name: "banchat_aviso_generico",
    label: "Aviso genérico de nuevas notificaciones",
    bodyText:
      "Hola. Tienes nuevas notificaciones. Pulsa el botón para revisarlas por aquí.",
    buttons: ["Revisar notificaciones"],
  },
] as const;
